import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SpeechRecognition } from '@capacitor-community/speech-recognition';
import { Capacitor } from '@capacitor/core';
import { AlertController, IonicModule, LoadingController, Platform } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import {  } from '@ionic/core';
import { AnimalService } from 'src/app/services/animal.service';
import { AgendaService } from 'src/app/services/agenda.service';
import { stripHtmlTags } from 'src/app/utils';
import { Animal } from 'src/app/models/animal';

@Component({
  selector: 'voice-recognition',
  templateUrl: './voice-recognition.component.html',
  styleUrls: ['./voice-recognition.component.scss'],
  imports: [CommonModule, IonicModule, TranslateModule],
  standalone: true,
})
export class VoiceRecognitionComponent  implements OnInit {
  environment = environment;
  @Input() header: string | null = null;
  @Input() subHeader: string | null = null;
  @Input() isCorrectionActivated: boolean = true;

  @Input() testString: string = "";
  @Input() testIs: boolean = false;

  @Output() eventDone = new EventEmitter<string>();
  @Output() eventCancel = new EventEmitter<any>();
  
  isSpeechRecognitionAvailable: boolean = false;
  speechRecognitionLatestResultDate: Date = new Date();
  speechRecognitionResult: string = '';
  speechRecognitionIsCancel: boolean = false;
  speechRecognitionIsRestarting: boolean = false;

  loading: HTMLIonLoadingElement | null = null;

  constructor(
    private translate: TranslateService,
    public alertController: AlertController,
    private platform: Platform,
    public loadingController: LoadingController,
    private userService: UserService,
    private http: HttpClient,
    private animalService: AnimalService,
    private agendaService: AgendaService) { }

  async ngOnInit() {
    this.isSpeechRecognitionAvailable = Capacitor.getPlatform() !== 'web' && (await SpeechRecognition.available()).available
  }

  async speechRecognitionFinish() {
    if(this.isCorrectionActivated) {

      this.presentLoading(this.translate.instant('Analysis and correction of the text'));

      var headers = new HttpHeaders({
        'content-type': 'application/json',
        'Authorization': this.userService.getHttpHeaders()
      });

      let animals: Animal[] | null = this.animalService.animals.filter(a => a.userId == this.userService.user?.id || a.isShareWithMe)
      let animalNames = (animals?.map(animal => animal.name).join(', ') ?? '') + (animals?.map(animal => animal.nameOfficial).join(', ') ?? '');
      let promptText = `Corrige les fautes des grammaires et des orthographes dans le texte suivant, Renvois UNIQUEMENT le texte corrigé. Le texte peut contenir le nom de mes animaux avec des erreurs d'orthographe, corrige les. Tu dois toujours privilégier les noms de mes animaux à d'autres noms. Les noms de mes animaux: ${animalNames}. Le texte à corriger : %s`;
      var formData = {
        'documentType': 'TextWithPrompt',
        'prompt': promptText,
        'nbResults': 1,
        'text': this.speechRecognitionResult,
      }
      this.http.post(environment.API_URL + 'IA/ws_private/ExecuteIA/', JSON.stringify(formData), {headers : headers}).subscribe(async (data: { [key: string]: any }) => {
        this.loading?.dismiss()

        if(data['resultIsQuerySuccess']) {
          this.eventDone.emit(stripHtmlTags(data['resultJson']))
        } else {
          this.eventDone.emit(this.speechRecognitionResult)
        }
      }, (error: any) => {
        this.loading?.dismiss()
        this.eventDone.emit(this.speechRecognitionResult)
      });
    } else {
      this.eventDone.emit(this.speechRecognitionResult)
    }
  }

  async speechRecognitionStart() {
    if(this.testIs) {
      this.speechRecognitionResult = this.testString
      this.speechRecognitionFinish()
      return
    }

    await SpeechRecognition.requestPermissions()

    var c = this.alertController.create({
      header: this.header ? this.translate.instant(this.header ?? ''): null,
      subHeader: this.subHeader ? this.translate.instant(this.subHeader ?? ''): null,
      message: '',
      buttons: [
        { text: this.translate.instant('Cancel'), handler: async (d) => {
            this.speechRecognitionIsCancel = true
            SpeechRecognition.stop();
          } 
        },
        { text: this.translate.instant('Restart'), handler: async (d) => {
            this.speechRecognitionIsRestarting = true;
            SpeechRecognition.stop();
            return false;
          } 
        },
        { text: this.translate.instant('Done'), handler: async (d) => {
          SpeechRecognition.stop();
        } },
      ]
    })
    c.then((c) => c.present());

    this.speechRecognitionLatestResultDate = new Date()
    this.speechRecognitionIsCancel = false
    this.speechRecognitionResult = ''

    SpeechRecognition.start({
      language: 'fr-FR',
      maxResults: 5,
      prompt: '',
      partialResults: true,
    });

    SpeechRecognition.addListener("partialResults", (data: any) => {
      this.speechRecognitionResult = data.matches[0]
      c.then((c) => c.message = this.speechRecognitionResult);
      this.speechRecognitionLatestResultDate = new Date()
    });

    SpeechRecognition.addListener("listeningState", (data: any) => {
      c.then((c) => c.dismiss());
      SpeechRecognition.removeAllListeners();
      if(this.speechRecognitionIsRestarting) {
        this.speechRecognitionIsRestarting = false;
        setTimeout(() => {
          this.speechRecognitionStart();
        }, 500);
      }
      else if(this.speechRecognitionIsCancel) {
        this.eventCancel.emit()
      }
      else {
        this.speechRecognitionFinish()
      }
    });
  }
  stopLoading() {
    this.loading?.dismiss();
    this.loading = null;
  }
  async presentLoading(label = null) {
    if(this.loading)
      this.stopLoading();

    this.loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: label ? label: this.translate.instant('Please wait...'),
      duration: 60000
    });
    await this.loading.present();
  }

}
